export const addAddressSelector = ({ facultyAddress }) => facultyAddress;
